import styled from 'styled-components';

export const List = styled.ul`
  margin-top: 20px;
  display: flex;
  flex-flow: row wrap;

  li {
    flex-basis: calc(33% - 25px);
    margin: 0 0 20px 20px;
    padding-bottom: 25px;
    border-bottom: 1px solid #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;

    @media (max-width: 768px){
      flex-basis: calc(50% - 25px);
    }

    @media (max-width: 480px){
      flex-basis: calc(100% - 25px);
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 auto 20px;
    }
  }
`;

export const Image = styled.div`
  max-height: 200px;
  text-align: center;

  @media (max-width: 480px){
    display: flex;
    justify-content: center;
  }

  img {
    max-width: 100%;
    max-height: 200px;
    min-width: 260px;
  }
`;

export const Head = styled.div`
  margin-top: 10px;
  width: 100%;
  overflow-wrap: break-word;

  a {
    h4 {
      &:hover {
        color: #edbd2f;
      }
    }
  }

  p {
    margin-top: 10px;
    font-weight: 300;
  }

  h4 {
    color: #fff;
    line-height: 24px;
    transition: color .35s linear;

    @media (max-width: 480px) {
      text-align: center;
    }
  }
`;

export const Meta = styled.div`
  margin-top: 10px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  @media (max-width: 500px){
    text-align: center;
  }

  img {
    max-width: 13px;
  }

  span {
    margin-left: 8px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
  }
`;

export const Content = styled.div`
  max-width: 100%;
  margin-top: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;

  > p {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
  }
  
  p {
    padding: 0 0 10px 0;
    line-height: 20px;
   }

  ul, ol {
    padding: 0 0 10px 30px;
    list-style-type: disc;
    line-height: 24px;
  }

  ol {
    list-style-type: decimal;
  }
`;

export const ImagesSection = styled.div`
  h2 {
    text-align: left;
    font-weight: 300;
    margin-bottom: 20px;
  }
`

export const Gallery = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  li {
    display: flex;
    margin-right: 15px;
    &:last-child {
      margin-right: 0;
    }
  }
  div {
    cursor: pointer;
    width: 25px;
    height: 25px;
    border-radius: 20px;
   
  }

  img {
    cursor: pointer;
    max-width: 200px;
    border-radius: 3px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    max-width: 140px;
    max-height: 140px;
    min-width: 140px;
    min-height: 140px;
    margin-bottom: 17px;
  }
`;



// WEBPACK FOOTER //
// ./src/system/news/components.js